import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientSmartGoals = (state, patientId) =>
  allModelsSelector(state, 'PatientSmartGoal', (s) => s.patientId === patientId).sort(
    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
  );
